module.exports = __webpack_public_path__ + "static/img/icon-02.06a0b46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/icon-02.png
// module id = bhCM
// module chunks = 1